import type { SVGProps } from 'react';

const SvgConversation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M17 8.12C17 4.19 13.41 1 9 1S1 4.2 1 8.12c0 1.62.62 3.18 1.75 4.44v3.43a1 1 0 0 0 1.44.9l3.54-1.74c.42.06.85.09 1.27.09 4.41 0 8-3.2 8-7.12m-8 5.13c-.42 0-.84-.04-1.25-.11-.21-.04-.43 0-.62.09L4.75 14.4v-2.23c0-.27-.11-.52-.29-.71C3.52 10.53 3 9.34 3 8.13 3 5.3 5.69 3.01 9 3.01s6 2.3 6 5.12-2.69 5.12-6 5.12m10.76-2.47c-.49-.25-1.09-.06-1.35.43-.25.49-.06 1.09.43 1.35 1.35.7 2.16 1.92 2.16 3.25 0 .9-.38 1.77-1.08 2.47a1 1 0 0 0-.29.71v1.41l-1.56-.77c-.19-.09-.41-.12-.62-.09-1.99.36-4.1-.52-4.99-2.07a.999.999 0 1 0-1.73 1c1.12 1.95 3.33 3.16 5.79 3.16q.48 0 .96-.06l2.72 1.34a1.01 1.01 0 0 0 .97-.05c.29-.18.47-.5.47-.85v-2.62c.89-1.02 1.38-2.27 1.38-3.57 0-2.07-1.24-3.99-3.24-5.03z"
    />
  </svg>
);
export default SvgConversation;
